// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__afh_Q","title":"AfterFrontImage_title__xA6tl"};